import type { RootState } from '~/store/store.ts';
export const selectTasksAdministrationRoles = (s: RootState) => s.tasks.administrationRoles.data;
export const selectTasksAdministrationRolesStatus = (s: RootState) =>
  s.tasks.administrationRoles.status;
export const selectTasksAdministrationTasks = (s: RootState) =>
  s.tasks.administrationTasks.data.tasks;
export const selectTasksAdministrationTasksStatus = (s: RootState) =>
  s.tasks.administrationTasks.status;
export const selectTasksAdministrationTasksError = (s: RootState) =>
  s.tasks.administrationTasks.error;
export const selectTasksAdministrationTasksPageConfiguration = (s: RootState) =>
  s.tasks.administrationTasks.data;
export const selectTasksPatchAssigneeStatus = (s: RootState) => s.tasks.patchAssignee.status;
export const selectTasksSupervisors = (s: RootState) => s.tasks.taskSupervisors.data;
export const selectTasksSupervisorsError = (s: RootState) => s.tasks.taskSupervisors.error;
export const selectTasksSupervisorsStatus = (s: RootState) => s.tasks.taskSupervisors.status;
export const selectTasksUakdoAccessStatus = (s: RootState) => s.tasks.uakdoAccess.status;
export const selectHasTasksUakdoResponsibleAccess = (s: RootState) =>
  s.tasks.uakdoAccess.data.hasResponsibleAccess;
export const selectHasTasksUakdoControllerAccess = (s: RootState) =>
  s.tasks.uakdoAccess.data.hasControllerAccess;
export const selectTasksUpdateStatus = (s: RootState) => s.tasks.updateStatus.status;
